import { useQuery } from '@tanstack/react-query';
import { Modal } from '@atoms/Modal';
import { Spinner } from '@atoms/Spinner';
import { ProductCard } from '@molecules/ProductCard';
import { catalogService } from '@services/catalogService';
import { useAddToCart } from '@/hooks/useAddToCart';
import type { Product, User } from '@/types';

interface ProductBrowserModalProps {
  wholesaler: User | null;
  onClose: () => void;
}

export function ProductBrowserModal({ wholesaler, onClose }: ProductBrowserModalProps) {
  const { requestAdd } = useAddToCart('/restaurant?tab=browse');

  const { data: products, isLoading } = useQuery({
    queryKey: ['restaurant', 'browser-modal', wholesaler?.id],
    queryFn: () => catalogService.getProducts({ wholesalerId: wholesaler!.id }),
    enabled: Boolean(wholesaler?.id),
  });

  const handleAdd = (product: Product) => {
    requestAdd(product);
  };

  return (
    <Modal
      open={Boolean(wholesaler)}
      onClose={onClose}
      title={wholesaler ? `${wholesaler.name} — Ürünler` : 'Ürünler'}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
          {(products ?? []).map((product) => (
            <ProductCard key={product.id} product={product} onAdd={handleAdd} />
          ))}
          {!products?.length && <p className="col-span-full text-center text-gray-500">Ürün yok</p>}
        </div>
      )}
    </Modal>
  );
}
